__turbopack_context__.v({
  "button": "loginButton-module-scss-module__Z2skdq__button",
  "icon": "loginButton-module-scss-module__Z2skdq__icon",
  "iconOpen": "loginButton-module-scss-module__Z2skdq__iconOpen",
  "logInBtnSpinner": "loginButton-module-scss-module__Z2skdq__logInBtnSpinner",
  "logInBtnSpinnerWrapper": "loginButton-module-scss-module__Z2skdq__logInBtnSpinnerWrapper",
  "loginButton": "loginButton-module-scss-module__Z2skdq__loginButton",
  "menuArrow": "loginButton-module-scss-module__Z2skdq__menuArrow",
  "menuContent": "loginButton-module-scss-module__Z2skdq__menuContent",
  "menuWrapper": "loginButton-module-scss-module__Z2skdq__menuWrapper",
  "planTag": "loginButton-module-scss-module__Z2skdq__planTag",
  "userProfileFallbackContainer": "loginButton-module-scss-module__Z2skdq__userProfileFallbackContainer",
});
